export const SpaceCooperationRepository = Symbol.for('SpaceCooperationRepository');
